import { CommandBar, CommandBarLink, CommandBarContainer } from 'components/layout/CommandBar';
import { PageHeader } from 'components/layout/PageHeader';
import { usePermissions, UserPermission, WriteOn } from 'modules/permissions';
import { useTranslation } from 'react-i18next';

interface GoodPracticeListHeaderProps {
   toggleFilterBar: () => void;
}

export const GoodPracticeListHeader = ({ toggleFilterBar }: GoodPracticeListHeaderProps) => {
   const { hasPermission } = usePermissions();
   const { t } = useTranslation();

   const items = () => {
      return hasPermission(WriteOn(UserPermission.NewObservation))
         ? [
              {
                 key: 'newObservation',
                 text: t('ObservationList.ReportNewButton'),
                 data: {
                    link: '/observation/new'
                 },
                 iconProps: { iconName: 'Add' },
                 commandBarButtonAs: CommandBarLink
              }
           ]
         : [];
   };

   return (
      <>
         <PageHeader>{t('ObservationList.GoodPracticeTitle')}</PageHeader>
         <CommandBarContainer>
            <CommandBar
               items={items()}
               farItems={[
                  {
                     key: 'filter',
                     text: t('ObservationList.Filter'),
                     cacheKey: 'filter',
                     iconProps: { iconName: 'Filter' },
                     iconOnly: true,
                     onClick: toggleFilterBar
                  }
               ]}
            />
         </CommandBarContainer>
      </>
   );
};
